/*global _ */
import BaseMixin from './base'

export default {
  data() {
    return {
      propDefs: {}
    }
  },
  mixins: [BaseMixin],
  methods: {
    getComponentClasses() {
      return [this.classes, ...this.getComponentExtraClasses()]
    },
    getComponentExtraClasses() {
      return []
    }
  }
}

